import {Component, OnInit} from '@angular/core';
import {Order} from '../../interfaces/order';
import {CountdownTimerModule} from 'ngx-countdown-timer';

import {Router} from '@angular/router';
import {UserService} from '../../services/user.service';
import {ToastrService} from 'ngx-toastr';
import {ItonicsAuthService} from '../../services/itonicsAuth.service';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  public linkItems;
  items = [];

  date = new Date();
  public todaysDate = moment(this.date).format('YYYY-MM-DD') + ' 01:30:00';

  public loggedInName: string;

  public loggedInGrp = [];

  public isAdmin = false;

  orderlist: Array<Order>;

  constructor(private router: Router, private toastr: ToastrService, private itonicsAuthService: ItonicsAuthService) {
  }

  ngOnInit() {
    this.linkItems = [
      {
        itemName: 'Home',
        route: '/home'
      },
      {
        itemName: 'Add Order',
        route: 'add-order'
      },
      {
        itemName: 'My Order',
        route: 'my-order'
      },
      {
        itemName: 'Todays Order',
        route: '/home/today/order/list'
      }
    ];

    this.itonicsAuthService.getCurrentUserDetails().subscribe(
      (user) => {
        this.loggedInName = user.name;
        localStorage.setItem('loggedInFullname', this.loggedInName);
      },
      (err) => {
        console.log(err);

        this.toastr.error(err.error);
        this.Logout();
      }
    );

    this.itonicsAuthService.getCurrentUserGrp().subscribe(
      (userGrp) => {
        this.loggedInGrp = userGrp;
        if (this.loggedInGrp.find((_grp) => _grp === 'Administrator')) {
          this.isAdmin = true;
        }
      },
      (err) => {
        console.log(err);

        this.toastr.error(err.error);
        this.Logout();
      }
    );
  }

  Logout() {
    this.itonicsAuthService.logout();
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/home/home.component.ts